import CategorizeShare from "./containers/CategorizeShare";
import ShareSomething from "./containers/ShareSomething";
import Thanks from "./containers/Thanks";
import NoMatch from "./containers/NoMatch";import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';

import Sniffr from 'sniffr';

class App extends Component {
	constructor(props) {
		super(props);

		this.state = {
			locationKey: null,
			origin: null,
			sourceType: props.sourceType,
			isMobile: this.isMobile(),
			recaptchaLoaded: false
		}
	}

	componentDidMount() {
		this.loadRecaptcha();
		window.addEventListener("message", this.handleWidgetMsg);
	}

	componentWillUnmount() {
		window.removeEventListener("message", this.handleWidgetMsg);
	}

	loadRecaptcha = () => {
		// Load reCAPTCHA v3 script manually
		if (typeof window !== 'undefined' && !window.grecaptcha) {
			const script = document.createElement('script');
			script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_ID}`;
			script.async = true;
			script.defer = true;
			script.onload = () => {
				window.grecaptcha.ready(() => {
					this.setState({ recaptchaLoaded: true });
				});
			};
			document.head.appendChild(script);
		} else if (window.grecaptcha) {
			window.grecaptcha.ready(() => {
				this.setState({ recaptchaLoaded: true });
			});
		}
	}

	executeRecaptcha = (action) => {
		return new Promise((resolve, reject) => {
			if (window.grecaptcha && this.state.recaptchaLoaded) {
				window.grecaptcha.execute(process.env.REACT_APP_RECAPTCHA_ID, { action })
					.then(token => {
						resolve(token);
					})
					.catch(error => {
						console.error('reCAPTCHA execution failed:', error);
						reject(error);
					});
			} else {
				console.warn('reCAPTCHA not loaded yet');
				reject(new Error('reCAPTCHA not loaded'));
			}
		});
	}

	isMobile = () => {
		let browserInfo = new Sniffr();
		browserInfo.sniff(window.navigator.userAgent);

		// Still iterating
		let suggestsMobile = browserInfo.device.name !== 'Unknown' || browserInfo.os.name === "android";
		console.info(`isMobile: ${suggestsMobile}`);
		console.info(browserInfo);
		return suggestsMobile;
	}

	handleWidgetMsg = e => {
		const {type, locationKey, locationContact, embeddedOn} = e.data;

		if(type && type === 'LOCATION_INFO') {
			this.setState({
				locationKey,
				locationContact,
				messageSource: e.source,
				embeddedOn
			});
		}
	}
	
	render() {
		return (
			<Routes>
				<Route
					path="/"
					element={
						<CategorizeShare
							isMobile={this.state.isMobile}
							messageSource={this.state.messageSource}
							locationContact={this.state.locationContact}
							executeRecaptcha={this.executeRecaptcha}
						/>
					}
				/>

				<Route
					path="/tip"
					element={
						<ShareSomething 
							isTip
							sourceType={this.state.sourceType}
							embeddedOn={this.state.embeddedOn}
							messageSource={this.state.messageSource}
							locationKey={this.state.locationKey}
							executeRecaptcha={this.executeRecaptcha}
						/>
					}
				/>

				<Route
					path="/share/:category"
					element={
						<ShareSomething
							embeddedOn={this.state.embeddedOn}
							sourceType={this.state.sourceType}
							locationKey={this.state.locationKey}
							executeRecaptcha={this.executeRecaptcha}
						/>
					}
				/>

				<Route
					path="/thanks/:category"
					element={
						<Thanks
							isMobile={this.state.isMobile}
							messageSource={this.state.messageSource}
							locationContact={this.state.locationContact}
							executeRecaptcha={this.executeRecaptcha}
						/>
					}
				/>

				<Route
					path="/thanks"
					element={
						<Thanks
							isMobile={this.state.isMobile}
							messageSource={this.state.messageSource}
							locationContact={this.state.locationContact}
							executeRecaptcha={this.executeRecaptcha}
						/>
					}
				/>

				{/* No match - 404 */}
				<Route
					path="*"
					element={<NoMatch />}
				/>
			</Routes>
		);
	}
}

export default App;